import { invoicesApi } from "@web-src/modules/api/createApi";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useInvoicesConfigList } from "./useInvoicesConfigList";

export const useInvoicesConfig = () => {
  const { entityId } = useEntitySelectedProvider();
  const { configId } = useInvoicesConfigList();
  const getReponseData = invoicesApi.useGetConfigQuery({
    entityId,
    configId,
  });
  const globalConfig = getReponseData.data?.data;

  return {
    config: globalConfig,
  };
};
